/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkRevenueRebate } from '../models/work-revenue-rebate';

@Injectable({ providedIn: 'root' })
export class WorkSelfserviceRevenueRebateService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `selfserviceRevenueRebateV2ControllerGetNextRevenueRebate()` */
  static readonly SelfserviceRevenueRebateV2ControllerGetNextRevenueRebatePath = '/v2/selfservice/revenue-rebate/getNextRevenueRebate/{actualRevenueRebateId}';

  /**
   * Get next revenue rebate information for authenticated contact.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `selfserviceRevenueRebateV2ControllerGetNextRevenueRebate()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceRevenueRebateV2ControllerGetNextRevenueRebate$Response(
    params: {

    /**
     * actualRevenueRebateId
     */
      actualRevenueRebateId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkRevenueRebate>> {
    const rb = new RequestBuilder(this.rootUrl, WorkSelfserviceRevenueRebateService.SelfserviceRevenueRebateV2ControllerGetNextRevenueRebatePath, 'get');
    if (params) {
      rb.path('actualRevenueRebateId', params.actualRevenueRebateId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkRevenueRebate>;
      })
    );
  }

  /**
   * Get next revenue rebate information for authenticated contact.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `selfserviceRevenueRebateV2ControllerGetNextRevenueRebate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  selfserviceRevenueRebateV2ControllerGetNextRevenueRebate(
    params: {

    /**
     * actualRevenueRebateId
     */
      actualRevenueRebateId: number;
    },
    context?: HttpContext
  ): Observable<WorkRevenueRebate> {
    return this.selfserviceRevenueRebateV2ControllerGetNextRevenueRebate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkRevenueRebate>): WorkRevenueRebate => r.body)
    );
  }

}
